import { FindQuery, UHC, GetOrderAssistInput } from '../../../../types';

import { iso6391By6392 } from '../mapping/languages';

const TELADOC_GARNER_PLAN = 'hcsc_compliant';

export const getFindQuery = (
  input: GetOrderAssistInput & {
    useGeoCoordinatesOnly: boolean;
    useGarnersSpecialtiesInput: boolean;
    pageSize: number;
  },
): FindQuery => {
  const {
    searchInput,
    options,
    anonymizedPatient,
    useGeoCoordinatesOnly,
    useGarnersSpecialtiesInput,
    pageSize,
  } = input;
  const {
    vimSpecialtyId,
    advancedSearch,
    icd,
    cpt,
    referredToPlaceOfService,
    address,
    insurer,
    insurancePlan,
    network,
  } = searchInput || {};
  if (!vimSpecialtyId) {
    throw new Error('No Vim specialty id provided!');
  }

  const { firstName, lastName, facilityName, npi } = advancedSearch || {};
  const { forceCost, pagination, radius, languageCode } = options || {};
  const { providerCacheId, paginationNumber } = pagination || {};

  const implementationSpecificFilters: UHC.SpecificFilters = {
    forceCost,
    providerCacheId,
    referredToPlaceOfService,
  };

  const teladocGarnerFilters = useGarnersSpecialtiesInput
    ? {
        tenantSpecificFilters: {
          networkId: network || '',
          plan: TELADOC_GARNER_PLAN,
          garnerSpecialty: vimSpecialtyId,
        },
      }
    : {};

  return {
    searchParams: {
      icd,
      cpt,
      geo: useGeoCoordinatesOnly
        ? {
            coordinates: address?.coordinates,
          }
        : {
            zip: address?.zipCode,
            addressLine1: address?.address1,
            addressLine2: address?.address2,
            city: address?.city,
            state: address?.state,
          },
      anonymizedPatient,
    },
    filters: {
      vimSpecialtyIds: [vimSpecialtyId],
      npiList: npi ? [npi] : undefined,
      provider: {
        firstName,
        lastName,
      },
      facility: {
        name: facilityName,
      },
      spokenLanguage: languageCode ? iso6391By6392[languageCode]?.iso6391Code : undefined,
      distance: radius,
      implementationSpecificFilters,
      ...(insurer && insurancePlan
        ? { memberPlan: `${insurer}-${insurancePlan}`.toUpperCase() }
        : {}),
    },
    ...teladocGarnerFilters,
    pagination: {
      pageNumber: paginationNumber ?? 1,
      pageSize,
    },
  };
};
